import React, { useEffect } from 'react';

import FormHeader from '../../components/shared/form/formHeader';
import ReunioesList from "../../components/reunioes/reunioesList";

import Button from '@material-ui/core/Button';


const Reunioes = (props) => {
  
  const { history } = props;

  const ActionButton = () => <Button variant="contained" onClick={() => history.push('/reuniao')}>Nova reunião</Button>;
  
  return (
    <div>
      <FormHeader  ActionButton={ActionButton} titulo="Reuniões"/>
      <ReunioesList history={history}/>
    </div>
  );
}

export default Reunioes;
